import React, { useEffect, useState } from "react";
import config from "../../config";
import { triggerNotification } from "../../component/message/Msg";
import { useParams, useNavigate } from "react-router-dom";
import Breadcrumb from "../../component/breadcrumb/Breadcrumb";
import Spinner from "../../component/loadingbar/Spinner";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import MediaPopup from "../../component/mediapopup/MediaPopup";
import DropZone from "../../component/dropzone/DropZone";
import GrapesEditor from "../GrapesJs/GrapesEditor";

const AddChapter = () => {
  const { token, user_type } = config;
  const { id } = useParams();
  const navigate = useNavigate();

  //-------------------------------------------------- state management --------------------------------------
  const [loading, setLoading] = useState(false);
  const [loadingPopup, setLoadingPopup] = useState(false);
  const [mediaList, setMediaList] = useState([]);

  const [chapterName, setChapterName] = useState("");
  const [passingMarks, setPassingMarks] = useState(1);
  const [enableCtrlSeq, setEnableCtrlSeq] = useState(false);
  const [descContents, setDescContents] = useState("");
  const [plans, setPlans] = useState([
    {
      price: "",
      duration: "",
      durationUnit: "days",
      promotional_price: "",
    },
  ]);
  const [imageLinkValue, setImageLinkValue] = useState("");
  const [imageFileValue, setImageFileValue] = useState();
  const [iconLinkValue, setIconLinkValue] = useState("");
  const [iconFileValue, setIconFileValue] = useState();
  const [videoList, setVideoList] = useState([
    {
      selectedVideoRadioId: "videolink",
      videoLinkValue: "",
      videoFileValue: null,
      freeVideo: true,
      selectedThumbnailRadioId: "videolink",
      thumbnail: "",
      thumbnailFileValue: null,
      videoTitle: "",
      videoDescription: "",
      topicContent: "",
      topicPdfFile: null,
      pdf_url: ""
    },
  ]);
  const [videoIndex4Media, setVideoIndex4Media] = useState(null);

  const handleChapterNameChange = (e) => {
    setChapterName(e.target.value);
  };
  const handlePassingMarksChange = (e) => {
    setPassingMarks(e.target.value);
  };
  const handleEnableControlSequence = () => {
    setEnableCtrlSeq(!enableCtrlSeq);
  };
  const handleDescContentsChange = (data) => {
    setDescContents(data);
  };
  const handleVideoDescContentsChange = (data, i) => {
    setVideoList((prevVideoList) => {
      const newVideoList = [...prevVideoList];
      newVideoList[i] = {
        ...newVideoList[i],
        videoDescription: data,
      };
      return newVideoList;
    });
  };
  const handlePlanChange = (e, i) => {
    setPlans((prevPlans) => {
      const newPlans = [...prevPlans];
      newPlans[i] = {
        ...newPlans[i],
        [e.target.name]: e.target.value,
      };
      return newPlans;
    });
  };
  const handleVideoListChange = (e, i) => {
    const { name, value, files } = e.target;

    setVideoList((prevVideoList) => {
      const newVideoList = [...prevVideoList];
      if (
        name === "videoLinkValue" &&
        newVideoList[i].selectedVideoRadioId === "videofile"
      ) {
        newVideoList[i].videoFileValue = files[0];
        newVideoList[i].videoLinkValue = value;
      } else if (
        name === "thumbnail" &&
        newVideoList[i].selectedThumbnailRadioId === "videofile"
      ) {
        newVideoList[i].thumbnailFileValue = files[0];
        newVideoList[i].thumbnail = value;
      } else if (
        name === "videoLinkValue" &&
        !newVideoList[i].selectedVideoRadioId === "videofile"
      ) {
        newVideoList[i].videoFileValue = null;
        newVideoList[i].videoLinkValue = value;
      } else if (
        name === "thumbnail" &&
        !newVideoList[i].selectedThumbnailRadioId === "videofile"
      ) {
        newVideoList[i].thumbnailFileValue = null;
        newVideoList[i].thumbnail = value;
      } else {
        newVideoList[i] = {
          ...newVideoList[i],
          [name]: value,
        };
      }
      return newVideoList;
    });
  };

  //-------------------------------------- clear form data --------------------------------------r
  const clearForm = () => {
    setChapterName("");
    setEnableCtrlSeq(false);
    setPassingMarks(1);
    setDescContents("");
    setPlans([
      {
        price: "",
        duration: "",
        durationUnit: "days",
        promotional_price: "",
      },
    ]);
    setImageLinkValue("");
    setIconLinkValue("");
    setVideoList([
      {
        selectedVideoRadioId: "videolink",
        videoLinkValue: "",
        videoFileValue: null,
        thumbnailFileValue: null,
        freeVideo: true,
        thumbnail: "",
        videoTitle: "",
        videoDescription: "",
      },
    ]);

    if (id) {
      navigate("/viewchapters");
    }
  };

  //--------------------------------------- functionality for plans  ---------------------------------------
  const handleAddPlanBtn = () => {
    setPlans((oldPlans) => {
      return [
        ...oldPlans,
        {
          price: "",
          duration: "",
          durationUnit: "days",
          promotional_price: "",
        },
      ];
    });
  };
  const handleRemovePlanBtn = (index) => {
    const planlist = [...plans];
    planlist.splice(index, 1);
    setPlans(planlist);
  };
  //--------------------------------------- functionality for Video  ---------------------------------------
  const handleAddVideoInputBtn = () => {
    setVideoList((oldVideoList) => {
      return [
        ...oldVideoList,
        {
          selectedVideoRadioId: "videolink",
          videoLinkValue: "",
          videoFileValue: null,
          thumbnailFileValue: null,
          freeVideo: false,
          thumbnail: "",
          videoTitle: "",
          videoDescription: "",
          topicContent: "",
          pdf_url: ""
        },
      ];
    });
  };

  const handleRemoveVideoBtn = (index) => {
    const newList = [...videoList];
    newList.splice(index, 1);
    setVideoList(newList);
  };

  const handleFreeChapBtn = (i) => {
    setVideoList((prevVideoList) => {
      const newVideoList = [...prevVideoList];
      newVideoList[i] = {
        ...newVideoList[i],
        freeVideo: !newVideoList[i].freeVideo,
      };
      return newVideoList;
    });
  };

  // --------------------------------------- Read / Select / Get Selected chapter data ---------------------------------------R
  const updateFieldValueSet = async () => {
    setLoading(true);
    try {
      await fetch(`${config.host_url}chapter/${decodeURIComponent(atob(id))}`, {
        method: "GET",
        headers: {
          token: token,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            //set video links


            if (data.data.videos) {

              const receivedVideos = data.data.videos;
              const transformedVideos = receivedVideos?.map((video) => {
                console.log("video", video);

                return {
                  cvid: video.cvid,
                  selectedVideoRadioId: "videolink",
                  videoLinkValue: video?.video_url,
                  freeVideo: video?.isfree === 1,
                  thumbnail: video?.thumbnail,
                  videoTitle: video?.title,
                  videoDescription: video?.video_description
                    ? video.video_description
                    : "",
                  topicContent: video?.topic_content
                    ? video.topic_content
                    : "",
                  topicPdf: video?.topicPdf
                    ? video.topicPdf
                    : "",
                  pdf_url: video?.pdf
                    ? video.pdf
                    : "",
                };
              });
              setVideoList(transformedVideos);
            }
            data.data.image_link && setImageLinkValue(data.data?.image_link);
            data.data.icon && setIconLinkValue(data.data?.icon);
            data.data.name && setChapterName(data.data?.name);
            data.data.description && setDescContents(data.data?.description);
            data.data.passing_marks &&
              setPassingMarks(data.data?.passing_marks);
            data.data.controlled_sequence &&
              setEnableCtrlSeq(
                data.data?.controlled_sequence === 1 ? true : false
              );
          } else if (data.status === 401) {
            // Invalid token
            triggerNotification("error", "Unauthenticated user");
          } else {
            // Handle other errors
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!!"
            );
          }
        });
    } catch (error) {
      triggerNotification("error", "Error fetching chapters.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id !== undefined) {
      updateFieldValueSet();
    }
  }, [id]);

  // ---------------------------------------  Image / video handle functions ---------------------------------------R
  const getMedia = () => {
    setLoadingPopup(true);
    fetch(`${config.host_url}media`, {
      method: "GET",
      headers: {
        token: token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          // Successful response, update the media list
          setMediaList(data.data);
        } else if (data.status === 401) {
          // Invalid token
          console.error("Invalid token");
        } else {
          // Handle other errors
          console.error("Internal server error");
        }
      })
      .catch((error) => {
        console.error("Error fetching media:", error);
      })
      .finally(() => {
        setLoadingPopup(false);
      });
  };

  useEffect(() => {
    // Fetch media items

    getMedia();
  }, [token]);

  //video
  const handleSelectVideoMedia = async (media) => {
    await setVideoList((prevVideoList) => {
      const newVideoList = [...prevVideoList];
      newVideoList[videoIndex4Media] = {
        ...newVideoList[videoIndex4Media],
        videoLinkValue: media.media_name,
      };
      return newVideoList;
    });
    // await setVideoLinkValue(media.media_name);
  };

  //handleSelectThumbnailMedia
  const handleSelectThumbnailMedia = async (media) => {
    await setVideoList((prevVideoList) => {
      const newVideoList = [...prevVideoList];

      newVideoList[videoIndex4Media] = {
        ...newVideoList[videoIndex4Media],
        thumbnail: media.media_name,
      };
      return newVideoList;
    });
  };

  // ------------------------------------- f / Video Radio button change ------------------------------------
  // Function to handle radio button change

  const handleVideoRadioChange = (e, i) => {
    setVideoList((prevVideoList) => {
      const newVideoList = [...prevVideoList];
      newVideoList[i] = {
        ...newVideoList[i],
        videoLinkValue: "",
        videoFileValue: null,

        selectedVideoRadioId: e.target.value,
      };
      return newVideoList;
    });
  };
  const handleThumbnailRadioChange = (e, i) => {
    setVideoList((prevVideoList) => {
      const newVideoList = [...prevVideoList];
      newVideoList[i] = {
        ...newVideoList[i],
        thumbnail: "",
        thumbnailFileValue: null,
        selectedThumbnailRadioId: e.target.value,
      };
      return newVideoList;
    });
  };

  const handleTopicPdfRadioChange = (e, i) => {
    setVideoList((prevVideoList) => {
      const newVideoList = [...prevVideoList];
      newVideoList[i] = {
        ...newVideoList[i],
        topicPdf: e.target.value,
      };
      return newVideoList;
    });
  };


  const handleFileUploadChange = (e, i) => {
    const file = e.target.files[0]; // Get the selected file from the input
    console.log("fillle", file);

    if (file) {
      setVideoList((prevVideoList) => {
        const newVideoList = [...prevVideoList]; // Create a new array to avoid mutating state
        newVideoList[i] = {
          ...newVideoList[i], // Copy existing properties
          topicPdfFile: file, // Save the selected file
        };
        return newVideoList; // Return the updated array
      });
    }
  };



  // ---------------------------------------------- save Chapter ----------------------------------------------------c

  const saveChapter = async () => {
    try {
      // Validate required fields before making the API request
      if (!chapterName.trim()) {
        triggerNotification("error", "Chapter name fields cannot be empty!!");
        return;
      }
      if (passingMarks > 100) {
        triggerNotification(
          "error",
          "Passing marks must be between 1 and 100."
        );
        return;
      }

      const formData = new FormData();

      // Append image_link: check if imageFileValue is a File, else append imageLinkValue as text
      if (imageFileValue instanceof File) {
        formData.append("image_link", imageFileValue);
      } else {
        formData.append("image_link", imageLinkValue || "");
      }

      // Append icon_link: check if iconFileValue is a File, else append iconLinkValue as text
      if (iconFileValue instanceof File) {
        formData.append("icon_link", iconFileValue);
      } else {
        formData.append("icon", iconLinkValue || "");
      }

      // Append other data
      formData.append("status", "3");
      formData.append("name", chapterName);
      formData.append("video_link", "");
      formData.append("description", descContents);
      formData.append("controlled_sequence", enableCtrlSeq ? "1" : "0");
      formData.append("passing_marks", passingMarks);

      videoList.forEach((videoItem, index) => {
        if (
          videoItem.selectedVideoRadioId === "videofile" &&
          videoItem.videoFileValue instanceof File
        ) {
          formData.append(`videos[${index}]`, videoItem.videoFileValue);
        } else {
          formData.append(`videos[${index}]`, videoItem.videoLinkValue || "");
        }

        if (
          videoItem.selectedThumbnailRadioId === "videofile" &&
          videoItem.thumbnailFileValue instanceof File
        ) {
          formData.append(`thumbnail[${index}]`, videoItem.thumbnailFileValue);
        } else {
          formData.append(`thumbnail[${index}]`, videoItem.thumbnail || "");
        }

        formData.append(`title[${index}]`, videoItem.videoTitle || "");
        formData.append(`topic_content[${index}]`, videoItem.topicContent || "");
        // Check if PDF file exists and append it
        if (videoItem.topicPdfFile instanceof File) {
          formData.append(`pdf[${index}]`, videoItem.topicPdfFile);  // Append the file
        } else {
          formData.append(`pdf[${index}]`, ""); // If no file, append an empty string or some default
        }
        formData.append(`pdf_url[${index}]`, videoItem.pdf_url); // If no file, append an empty string or some default
        formData.append(
          `video_description[${index}]`,
          videoItem.videoDescription || ""
        );
        formData.append(`isfree[${index}]`, videoItem.freeVideo ? "1" : "0");
      });

      plans.forEach((plan, index) => {
        formData.append(`plan_for[${index}]`, plan.duration || "");
        formData.append(`plan_unit[${index}]`, plan.durationUnit || "");
        formData.append(`plan_price[${index}]`, plan.price || "");
        formData.append(
          `promotional_price[${index}]`,
          plan.promotional_price || ""
        );
      });

      fetch(
        `${config.host_url}chapter/${id ? decodeURIComponent(atob(id)) : ""}`,
        {
          method: `${id ? "PUT" : "POST"}`,
          headers: {
            token: token,
          },
          body: formData,
        }
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            // Chapter created successfully
            triggerNotification("success", `Chapter saved successfully.`);
            // Reset form fields after successful creation
            setImageLinkValue("");
            setIconLinkValue("");
            setChapterName("");
            setEnableCtrlSeq(false);
            setPassingMarks(1);
            setDescContents("");
            setVideoList([
              {
                selectedVideoRadioId: "videolink",
                videoLinkValue: "",
                videoFileValue: null,
                thumbnailFileValue: null,
                freeVideo: true,
                thumbnail: "",
                videoTitle: "",
                videoDescription: "",
                topicPdfFile: null,
              },
            ]);
            setPlans([
              {
                price: "",
                duration: "",
                durationUnit: "days",
                promotional_price: "",
              },
            ]);
            navigate("/viewchapters");
          } else if (data.status === 400) {
            // Handle validation errors
            triggerNotification("error", "Validation Error.");
          } else if (data.status === 401) {
            // Handle unauthorized (invalid token)
            triggerNotification("error", "Unauthenticated user");
          } else {
            // Handle other server errors
            triggerNotification("error", "Internal server error.");
          }
        })
        .catch((error) => {
          // Handle fetch error here
          triggerNotification("error", "Please try after sometime");
          console.error("Fetch error:", error);
        });
    } catch (error) {
      console.error("Error saving chapter:", error);
      triggerNotification(
        "error",
        "An error occurred while saving the chapter."
      );
    }
  };
  const updateTopicContent = async (topicContent, id) => {
    try {


      const response = await fetch(`${config.host_url}update-content`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json", // Ensure the content type is set to JSON
        },
        body: JSON.stringify({
          topic_content: topicContent || "",
          cvid: id,
        }),
      });

      const data = await response.json();

    } catch (error) {
      console.error("Error updating content:", error);
    }

  }
  // ---------------------------------------------- create / add Chapter ----------------------------------------------------c
  // Function to create a new Chapter
  const createChapter = async () => {
    try {
      if (!chapterName.trim()) {
        triggerNotification("error", "Chapter name fields cannot be empty!!");
        return;
      }
      if (passingMarks > 100) {
        triggerNotification(
          "error",
          "Passing marks must be between 1 and 100."
        );
        return;
      }

      const formData = new FormData();

      // Append image_link: check if imageFileValue is a File, else append imageLinkValue as text
      if (imageFileValue instanceof File) {
        formData.append("image_link", imageFileValue);
      } else {
        formData.append("image_link", imageLinkValue || "");
      }

      // Append icon_link: check if iconFileValue is a File, else append iconLinkValue as text
      if (iconFileValue instanceof File) {
        formData.append("icon_link", iconFileValue);
      } else {
        formData.append("icon", iconLinkValue || "");
      }

      // Append other data
      formData.append("status", user_type === "TPT" ? "0" : "1");
      formData.append("name", chapterName);
      formData.append("video_link", "");
      formData.append("description", descContents);
      formData.append("controlled_sequence", enableCtrlSeq ? "1" : "0");
      formData.append("passing_marks", passingMarks);



      videoList.forEach((videoItem, index) => {
        if (
          videoItem.selectedVideoRadioId === "videofile" &&
          videoItem.videoFileValue instanceof File
        ) {
          formData.append(`videos[${index}]`, videoItem.videoFileValue);
        } else {
          formData.append(`videos[${index}]`, videoItem.videoLinkValue || "");
        }

        if (
          videoItem.selectedThumbnailRadioId === "videofile" &&
          videoItem.thumbnailFileValue instanceof File
        ) {
          formData.append(`thumbnail[${index}]`, videoItem.thumbnailFileValue);
        } else {
          formData.append(`thumbnail[${index}]`, videoItem.thumbnail || "");
        }

        formData.append(`title[${index}]`, videoItem.videoTitle || "");
        // formData.append(`topic_content[${index}]`, videoItem.topicContent || "");
        formData.append(`topic_content[${index}]`, "");

        // Check if PDF file exists and append it
        if (videoItem.topicPdfFile instanceof File) {
          formData.append(`pdf[${index}]`, videoItem.topicPdfFile);  // Append the file
        } else {
          formData.append(`pdf[${index}]`, ""); // If no file, append an empty string or some default
        }
        formData.append(`pdf_url[${index}]`, videoItem.pdf_url); // If no file, append an empty string or some default
        formData.append(`thumbnail_url[${index}]`, videoItem.thumbnail || "");
        formData.append(`video_url[${index}]`, videoItem.videoLinkValue || "");
        formData.append(
          `video_description[${index}]`,
          videoItem.videoDescription || ""
        );
        formData.append(`isfree[${index}]`, videoItem.freeVideo ? "1" : "0");
      });
      formData.forEach((v, k) => {
        console.log(k, v);

      })


      plans.forEach((plan, index) => {
        formData.append(`plan_for[${index}]`, plan.duration || "");
        formData.append(`plan_unit[${index}]`, plan.durationUnit || "");
        formData.append(`plan_price[${index}]`, plan.price || "");
        formData.append(
          `promotional_price[${index}]`,
          plan.promotional_price || ""
        );
      });
      fetch(
        `${config.host_url}chapter/${id ? decodeURIComponent(atob(id)) : ""}`,
        {
          method: `${id ? "PUT" : "POST"}`,
          headers: {
            token: token,
          },
          body: formData,
        }
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            // Chapter created successfully
            triggerNotification(
              "success",
              `Chapter ${id ? "updated" : "created"} successfully.`
            );
            // Reset form fields after successful creation
            setImageLinkValue("");
            setIconLinkValue("");
            setChapterName("");
            setDescContents("");
            setEnableCtrlSeq(false);
            setPassingMarks(1);
            setVideoList([
              {
                selectedVideoRadioId: "videolink",
                videoLinkValue: "",
                videoFileValue: null,
                thumbnailFileValue: null,
                freeVideo: true,
                thumbnail: "",
                videoTitle: "",
                videoDescription: "",
                topicPdfFile: null,
              },
            ]);
            setPlans([
              {
                price: "",
                duration: "",
                durationUnit: "days",
                promotional_price: "",
              },
            ]);
            navigate("/viewchapters");
          } else if (data.status === 400) {
            // Handle validation errors
            triggerNotification("error", "Validation Error.");
          } else if (data.status === 401) {
            // Handle unauthorized (invalid token)
            triggerNotification("error", "Unauthenticated user");
          } else {
            // Handle other server errors
            triggerNotification("error", "Internal server error.");
          }
        })
        .catch((error) => {
          // Handle fetch error here
          triggerNotification("error", "Please try after sometime");
          console.error("Fetch error:", error);
        });
    } catch (error) {
      console.error("Error creating chapter:", error);
      triggerNotification(
        "error",
        "An error occurred while creating the chapter."
      );
    }
  };

  const handleMessageFromChild = (html, i, id) => {
    setVideoList((prevList) => {
      const updatedList = [...prevList];
      updatedList[i] = {
        ...updatedList[i],
        topicContent: `<style>${html.css}</style>${html.html}`,
      };

      console.log(videoList[i]);

      updateTopicContent(updatedList[i].topicContent, id);
      return updatedList;
    });


  };


  // Separate arrays for videos and images
  const videos = mediaList.filter((media) => media.media_type === "video");
  const thumbImages = mediaList.filter((media) => media.media_type === "image");

  return (
    <>
      <Breadcrumb txt="Manage Chapter" subpath={["Add Chapter"]} />
      {/* form view */}
      <DropZone url="chapter/excel" navigate="viewchapters" type="chap" />
      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header d-flex align-items-center ">
            <h5 className="mb-0">Add Chapter</h5>
          </div>
          <div className="card-body">
            <form>
              {loading ? (
                <Spinner />
              ) : (
                <>
                  {/* Chapter Name */}
                  <div className="form-floating form-floating-outline mb-4">
                    <input
                      type="text"
                      className="form-control"
                      id="chapname"
                      placeholder="Chapter Name"
                      value={chapterName}
                      onChange={handleChapterNameChange}
                    />
                    <label htmlFor="chapname">Chapter Name</label>
                  </div>
                </>
              )}
              <div className={loading ? "d-none" : "d-block"}>
                {/*  Description */}
                <label htmlFor="editor" className="form-check-label ml-1 mb-2">
                  Description
                </label>
                <div className="form-floating form-floating-outline mb-4">
                  <CKEditor
                    id="editor"
                    name="Desc"
                    editor={ClassicEditor}
                    data={descContents}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      handleDescContentsChange(data);
                    }}
                  />
                </div>
                <div className="row">
                  {/*  Enable Control Sequence checkbox */}
                  <div className="col-md-4">
                    <div
                      className=" select-none"
                      id="enableCtrlSeq"
                      name="enableCtrlSeq"
                      onClick={handleEnableControlSequence}
                    >
                      {enableCtrlSeq ? (
                        <span className="mdi mdi-checkbox-marked-outline mr-3  "></span>
                      ) : (
                        <span className="mdi mdi-checkbox-blank-outline mr-3 "></span>
                      )}
                      <span> Enable Control Sequence</span>
                    </div>
                  </div>
                  {/* Passing Marks */}
                  <div className="col-md-8">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="number"
                        min={1}
                        max={100}
                        className="form-control"
                        id="pas singmarks"
                        placeholder="Passing Marks (in %)"
                        value={passingMarks}
                        onChange={handlePassingMarksChange}
                      />
                      <label htmlFor="passingmarks">Passing Marks (in %)</label>
                    </div>
                  </div>
                </div>

                {/* Plans */}
                {!id && (
                  <>
                    <div>
                      <label className="form-check-label ml-1 mb-2">
                        Plans
                      </label>
                      {plans.map((plan, i) => (
                        <div key={i} className="row">
                          {/*  Duration */}
                          <div className="col-md-2">
                            <div className="form-floating form-floating-outline mb-4  ">
                              <input
                                type="number"
                                min="1"
                                id="basic-default-phone"
                                className="form-control phone-mask"
                                placeholder="Duration"
                                value={plan.duration}
                                name="duration"
                                onChange={(e) => handlePlanChange(e, i)}
                              />
                              <label htmlFor="basic-default-phone">
                                Duration
                              </label>
                            </div>
                          </div>
                          {/* Duration unit */}
                          <div className="col-sm-2">
                            <div className="form-floating form-floating-outline mb-4">
                              <select
                                className="form-select"
                                id="exampleFormControlSelect1"
                                aria-label="Default select example"
                                value={plan.durationUnit}
                                name="durationUnit"
                                onChange={(e) => handlePlanChange(e, i)}
                              >
                                <option value="days">Days</option>
                                <option value="weeks">Weeks</option>
                                <option value="months">Months</option>
                              </select>
                              <label htmlFor="exampleFormControlSelect1">
                                Duration Unit
                              </label>
                            </div>
                          </div>
                          {/* Price */}
                          <div className="col-md-3">
                            <div className="form-floating form-floating-outline mb-4 ">
                              <input
                                type="number"
                                min="1"
                                id="basic-default-phone"
                                className="form-control phone-mask"
                                placeholder="Price"
                                value={plan.price}
                                name="price"
                                onChange={(e) => handlePlanChange(e, i)}
                              />
                              <label htmlFor="basic-default-phone">Price</label>
                            </div>
                          </div>

                          {/* promotional_price */}
                          <div className="col-md-3">
                            <div className="form-floating form-floating-outline mb-4 ">
                              <input
                                type="number"
                                min="1"
                                id="basic-default-phone"
                                className="form-control phone-mask"
                                placeholder="Promotional Price"
                                value={plan.promotional_price}
                                name="promotional_price"
                                onChange={(e) => handlePlanChange(e, i)}
                              />
                              <label htmlFor="basic-default-phone">
                                Promotional Price
                              </label>
                            </div>
                          </div>
                          {/* cancel plan */}
                          {i > 0 && (
                            <div
                              className="text-red-600 col-sm-2 select-none"
                              onClick={() => handleRemovePlanBtn(i)}
                            >
                              <span className="mdi mdi-close pr-2"></span>
                              Remove Plan
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                    <button
                      type="button"
                      className="btn btn-outline-secondary mb-4 "
                      onClick={() => handleAddPlanBtn()}
                    >
                      Add More Plan
                    </button>
                    <hr className="mb-4 mt-2" />
                  </>
                )}

                {/* Image Link */}

                <MediaPopup
                  ttl="Image"
                  linkValue={imageLinkValue}
                  setLinkValue={setImageLinkValue}
                  setFileValue={setImageFileValue}
                  mediaType="images"
                />
                <hr className="mb-4 mt-2" />

                {/* Icon Link */}

                <MediaPopup
                  ttl="Icon"
                  linkValue={iconLinkValue}
                  setLinkValue={setIconLinkValue}
                  setFileValue={setIconFileValue}
                  mediaType="images"
                />
                <hr className="mb-4 mt-2" />

                {/* Topic Link */}

                <p className="form-check-label ml-1">Topic</p>
                <div className="accordion mt-3" id="accordionTopic">
                  {videoList.map((videoItem, i) => (
                    <>
                      <div className="accordion-item">
                        <h2 className="accordion-header" id={`heading${i}`}>
                          <div className="flex ">
                            <button
                              type="button"
                              className="accordion-button collapsed"
                              data-bs-toggle="collapse"
                              data-bs-target={`#accordion${i}`}
                              aria-expanded="false"
                              aria-controls={`accordion${i}`}
                            >
                              {videoItem?.videoTitle
                                ? videoItem.videoTitle
                                : `Topic ${i + 1}`}
                            </button>
                            {i > 0 && (
                              <span
                                className="text-red-600  select-none"
                                onClick={() => handleRemoveVideoBtn(i)}
                              >
                                <span className="mdi mdi-delete pr-2 text-sm	mr-2"></span>
                              </span>
                            )}
                          </div>
                        </h2>
                        <div
                          id={`accordion${i}`}
                          className="accordion-collapse collapse"
                          aria-labelledby={`heading${i}`}
                          data-bs-parent="#accordionTopic"
                        >
                          <div className="mx-3" key={i}>
                            <div className="col mt-2">
                              {/* Topic Title */}
                              <div className="col-md-12">
                                <div className="form-floating form-floating-outline mb-4">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="videoTitle"
                                    name="videoTitle"
                                    placeholder="Topic Title"
                                    value={videoItem?.videoTitle}
                                    onChange={(e) =>
                                      handleVideoListChange(e, i)
                                    }
                                  />
                                  <label htmlFor="videoTitle">
                                    Topic Title
                                  </label>
                                </div>
                              </div>

                              {/*  Topic Description */}
                              <label
                                htmlFor="videoDescription"
                                className="form-check-label ml-1 mb-2"
                              >
                                Topic Description
                              </label>
                              <div className="form-floating form-floating-outline mb-4">
                                <CKEditor
                                  id="videoDescription"
                                  name="videoDescription"
                                  editor={ClassicEditor}
                                  data={videoItem?.videoDescription}
                                  onChange={(event, editor) => {
                                    const data = editor.getData();
                                    handleVideoDescContentsChange(data, i);
                                  }}
                                />
                              </div>

                              {/* Topic Content Editor */}
                              <div>
                                <h6>Topic Content</h6>
                                {loading ? <></> : <GrapesEditor
                                  onSave={(content) => handleMessageFromChild(content, i, videoItem?.cvid)}
                                  components={videoItem?.topicContent}
                                  index={i}
                                />}
                              </div>


                              {/* videolink input |  set as free */}
                              <>
                                {/* radio */}
                                <div>
                                  <div className="form-check form-check-inline ml-1">
                                    <input
                                      defaultChecked
                                      name={`form-check-group-video-${i}`}
                                      className="form-check-input"
                                      type="radio"
                                      value="videolink"
                                      id={`videolink${i}`}
                                      onChange={(e) =>
                                        handleVideoRadioChange(e, i)
                                      }
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor={`videolink${i}`}
                                    >
                                      Enter Link
                                    </label>
                                  </div>
                                  <div className="form-check form-check-inline">
                                    <input
                                      name={`form-check-group-video-${i}`}
                                      className="form-check-input"
                                      type="radio"
                                      value="videomedia"
                                      id={`videomedia${i}`}
                                      onChange={(e) =>
                                        handleVideoRadioChange(e, i)
                                      }
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor={`videomedia${i}`}
                                    >
                                      Import Form Media
                                    </label>
                                  </div>
                                  <div className="form-check form-check-inline">
                                    <input
                                      name={`form-check-group-video-${i}`}
                                      className="form-check-input"
                                      type="radio"
                                      value="videofile"
                                      id={`videofile${i}`}
                                      onChange={(e) =>
                                        handleVideoRadioChange(e, i)
                                      }
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor={`videofile${i}`}
                                    >
                                      Upload a File
                                    </label>
                                  </div>
                                </div>
                                {/* videolink input |  set as free  */}
                                <div className="row">
                                  {/* videolink input */}
                                  <div
                                    className={`col-md-${videoItem?.selectedVideoRadioId ===
                                      "videomedia"
                                      ? 8
                                      : 9
                                      }`}
                                  >
                                    <div className="form-floating form-floating-outline mb-4">
                                      <input
                                        type={`${videoItem?.selectedVideoRadioId ===
                                          "videofile"
                                          ? "file"
                                          : "text"
                                          }`}
                                        className="form-control"
                                        id="videoLinkValue"
                                        name="videoLinkValue"
                                        placeholder="Enter Topic Video Link"
                                        disabled={
                                          videoItem?.selectedVideoRadioId ===
                                          "videomedia"
                                        }
                                        value={videoItem?.videoLinkValue}
                                        onChange={(e) =>
                                          handleVideoListChange(e, i)
                                        }
                                        {...(videoItem?.selectedVideoRadioId ===
                                          "videofile" && {
                                          accept: "video/*",
                                        })}
                                      />
                                      <label htmlFor="videoLinkValue">
                                        {videoItem?.selectedVideoRadioId ===
                                          "videolink"
                                          ? "Enter Topic Video Link"
                                          : "Choose Topic Video Media "}
                                      </label>
                                    </div>
                                  </div>
                                  {/* upload btn if (videomedia) */}
                                  {videoItem?.selectedVideoRadioId ===
                                    "videomedia" && (
                                      <div className="col-md-1 ">
                                        <div className="mb-4">
                                          <button
                                            id="media"
                                            type="button"
                                            className="btn btn-secondary w-full h-[45px]"
                                            data-bs-toggle="modal"
                                            data-bs-target="#addNewVideoModal"
                                            onClick={async () => {
                                              await setVideoIndex4Media(i);
                                            }}
                                          >
                                            <span className="tf-icons mdi mdi-upload"></span>
                                          </button>
                                        </div>
                                      </div>
                                    )}
                                  {/* set as free */}
                                  <div className="col-sm-3  ">
                                    <div
                                      className="mb-4 font-bold h-[45px] bg-green-600 px-3 select-none flex justify-center items-center rounded text-white"
                                      onClick={() => handleFreeChapBtn(i)}
                                    >
                                      {videoItem?.freeVideo ? (
                                        <span className="mdi mdi-checkbox-marked-outline mr-3  "></span>
                                      ) : (
                                        <span className="mdi mdi-checkbox-blank-outline mr-3 "></span>
                                      )}
                                      SET AS FREE
                                      <span
                                        style={{
                                          visibility: videoItem?.freeVideo
                                            ? "hidden"
                                            : "visible",
                                        }}
                                      >
                                        ?
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </>

                              {/* Thumbnail */}
                              <div className="row">
                                {/* Thumbnail radiio */}
                                <div className="col-md-12">
                                  <div>
                                    <div className="form-check form-check-inline ml-1">
                                      <input
                                        defaultChecked
                                        name={`thumbnail-${i}`}
                                        className="form-check-input"
                                        type="radio"
                                        value="videolink"
                                        id={`tmbnllnk${i}`}
                                        onChange={(e) =>
                                          handleThumbnailRadioChange(e, i)
                                        }
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor={`tmbnllnk${i}`}
                                      >
                                        Enter Link
                                      </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                      <input
                                        name={`thumbnail-${i}`}
                                        className="form-check-input"
                                        type="radio"
                                        value="videomedia"
                                        id={`tmbnlmda${i}`}
                                        onChange={(e) =>
                                          handleThumbnailRadioChange(e, i)
                                        }
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor={`tmbnlmda${i}`}
                                      >
                                        Import Form Media
                                      </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                      <input
                                        name={`thumbnail-${i}`}
                                        className="form-check-input"
                                        type="radio"
                                        value="videofile"
                                        id={`tmbnlfile${i}`}
                                        onChange={(e) =>
                                          handleThumbnailRadioChange(e, i)
                                        }
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor={`tmbnlfile${i}`}
                                      >
                                        Upload a File
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                {/* Thumbnail inputBox */}
                                <div
                                  className={`col-lg-${videoItem?.selectedThumbnailRadioId ===
                                    "videomedia"
                                    ? 10
                                    : 12
                                    }`}
                                >
                                  <div className="form-floating form-floating-outline mb-4">
                                    <input
                                      type={`${videoItem?.selectedThumbnailRadioId ===
                                        "videofile"
                                        ? "file"
                                        : "text"
                                        }`}
                                      className="form-control"
                                      id="thumbnail"
                                      name="thumbnail"
                                      placeholder="Enter Thumbnail Link"
                                      value={videoItem?.thumbnail}
                                      disabled={
                                        videoItem?.selectedThumbnailRadioId ===
                                        "videomedia"
                                      }
                                      onChange={(e) =>
                                        handleVideoListChange(e, i)
                                      }
                                      {...(videoItem?.selectedThumbnailRadioId ===
                                        "videofile" && {
                                        accept: "image/*",
                                      })}
                                    />
                                    <label htmlFor="thumbnail">
                                      {videoItem?.selectedThumbnailRadioId ===
                                        "videolink"
                                        ? "Enter Thumbnail Link"
                                        : "Choose Thumbnail Media "}
                                    </label>
                                  </div>
                                </div>
                                {/* thumbnail upload btn if (videomedia) */}
                                {videoItem?.selectedThumbnailRadioId ===
                                  "videomedia" && (
                                    <div className="col-sm-2 ">
                                      <div className="mb-4">
                                        <button
                                          id="media"
                                          type="button"
                                          className="btn btn-secondary w-full h-[45px]"
                                          data-bs-toggle="modal"
                                          data-bs-target="#addNewThumbnailModal"
                                          onClick={async () => {
                                            await setVideoIndex4Media(i);
                                          }}
                                        >
                                          <span className="tf-icons mdi mdi-upload"></span>
                                        </button>
                                      </div>
                                    </div>
                                  )}
                              </div>

                              {/* PDF */}
                              <div className="row">
                                <div className="col-lg-12">
                                  <div className="form-floating form-floating-outline mb-4">
                                    <input
                                      type="file"
                                      className="form-control"
                                      id={`topicPdfFile-${i}`} // Unique ID for each input
                                      name={`topicPdfFile-${i}`}
                                      accept=".pdf"
                                      onChange={(e) => handleFileUploadChange(e, i)} // Pass event and index
                                    />
                                    <label htmlFor={`topicPdfFile-${i}`}>Choose a PDF File to Upload</label>

                                    {videoItem?.pdf_url.length > 0 && (<a href={videoItem?.pdf_url} target="_blank">Preview File</a>)}
                                  </div>
                                </div>
                              </div>








                            </div>
                            <hr className="mb-4 mt-2" />
                          </div>
                        </div>
                      </div>
                    </>
                  ))}
                </div>

                <button
                  type="button"
                  className="btn mt-2 btn-outline-secondary mb-4 "
                  onClick={() => handleAddVideoInputBtn()}
                >
                  Add More Topic
                </button>
                {/* <hr className="mb-4 mt-2" /> */}

                {/* submit | save | calcel */}
                <div className="mt-8 justify-content-end">
                  <div>
                    {/* save */}
                    <button
                      type="button"
                      className="btn mr-2 btn-info"
                      onClick={saveChapter}
                    >
                      save
                    </button>
                    {/* submit */}
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={createChapter}
                    >
                      {id ? "Update" : "Submit"}
                    </button>
                    {/* clear - calcel */}
                    <button
                      type="button"
                      className="btn ml-2 btn-secondary"
                      onClick={clearForm}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
          {/* )} */}
        </div>
      </div>

      {/* Thumbnail popup */}
      <div
        className="modal fade"
        id="addNewThumbnailModal"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-simple modal-add-new-cc">
          <div className="modal-content p-3 p-md-5">
            <div className="modal-body p-md-0">
              <div className="flex">
                <h5 className="p-0 m-0 pb-3">Select Thumbnail Image</h5>
                <button
                  type="button"
                  className=" ml-3 pb-3 "
                  onClick={() => {
                    getMedia();
                  }}
                >
                  <span className="mdi mdi-refresh"></span>
                </button>
                <a
                  type="button"
                  className=" ml-3 pb-3 "
                  target="_blank"
                  href="/addmedia"
                >
                  <span className="mdi mdi-cloud-upload"></span>
                </a>
              </div>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              // onClick={clearSelectedMedia}
              ></button>

              {loadingPopup ? (
                <Spinner />
              ) : (
                <>
                  <div className="row">
                    {thumbImages.map((thumbMedia) => (
                      <div className="col-md-3 mb-3" key={thumbMedia.media_id}>
                        <div className="form-check custom-option custom-option-image custom-option-image-check border-0  ">
                          <input
                            className="form-check-input invisible"
                            id={`thumbImg${thumbMedia.media_id}`}
                            type="radio"
                            onChange={() =>
                              handleSelectThumbnailMedia(thumbMedia)
                            }
                          />
                          <label
                            className="form-check-label custom-option-content"
                            htmlFor={`thumbImg${thumbMedia.media_id}`}
                          >
                            <div className="custom-option-body h-24">
                              <img
                                src={thumbMedia.media_name}
                                alt={`thumbImg_${thumbMedia.media_id}`}
                              />
                            </div>
                          </label>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="d-flex justify-content-end">
                    <button
                      type="button"
                      className="btn btn-primary"
                      data-bs-dismiss="modal"
                    >
                      Select
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* video popup  */}
      <div
        className="modal fade"
        id="addNewVideoModal"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-simple modal-add-new-cc">
          <div className="modal-content p-3 p-md-5 ">
            <div className="modal-body p-md-0">
              <div className="flex">
                <h5 className="p-0 m-0 pb-3">Select Video</h5>
                <button
                  type="button"
                  className=" ml-3 pb-3 "
                  onClick={() => {
                    getMedia();
                  }}
                >
                  <span className="mdi mdi-refresh"></span>
                </button>
                <a
                  type="button"
                  className=" ml-3 pb-3 "
                  target="_blank"
                  href="/addmedia"
                >
                  <span className="mdi mdi-cloud-upload"></span>
                </a>
              </div>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>

              {loadingPopup ? (
                <Spinner />
              ) : (
                <>
                  <div className="row">
                    {videos.map((media) => (
                      <div className="col-md-3 mb-3" key={media.media_id}>
                        <div className="form-check custom-option custom-option-image custom-option-image-check border-0 ">
                          <input
                            className="form-check-input invisible"
                            id={"video" + media.media_id}
                            type="radio"
                            value={media.media_id}
                            onClick={() => handleSelectVideoMedia(media)}
                          />
                          <label
                            className="form-check-label custom-option-content"
                            htmlFor={"video" + media.media_id}
                          >
                            <div className="custom-option-body h-24">
                              <video width="100%" height="100%">
                                <source
                                  src={media.media_name}
                                  type="video/mp4"
                                />
                              </video>
                            </div>
                          </label>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="d-flex justify-content-end">
                    <button
                      type="button"
                      className="btn btn-primary"
                      data-bs-dismiss="modal"
                    >
                      Select
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddChapter;
